import { useTranslation } from 'next-i18next'

import { useAppSelector } from '~/redux/hooks'

import useGetGradePageRoute from '~/dashboard/hooks/useGetGradePageRoute'

import CircleIconButton from '~/bootcamp/components/CircleIconButton'

import { useGetCurriculumCountryCodeFromUrlWithoutPrefix } from '../hooks/useGetCurriculumCountryCode'
import { selectPreviousPage } from '../slice/curriculum.slice'

export default function CurriculumHeader({
  title,
  shouldShowBackButton,
  showIntroductionSubtitle,
}: {
  title: string
  shouldShowBackButton?: boolean
  showIntroductionSubtitle?: boolean
}): React.ReactElement {
  const countryCodeFromUrl = useGetCurriculumCountryCodeFromUrlWithoutPrefix()
  const { t } = useTranslation('curriculum')
  const prevPage = useAppSelector(selectPreviousPage)
  const gradePageRoute = useGetGradePageRoute({ specificCountryCode: countryCodeFromUrl })
  return (
    <>
      {shouldShowBackButton && (
        <div className="absolute top-1 left-0 z-20">
          <CircleIconButton
            className="w-8 h-8 p-2 bg-white"
            iconColor="text-purple"
            iconName="arrow-left-bold"
            link={prevPage ? prevPage : gradePageRoute}
          />
        </div>
      )}
      <div className="relative flex flex-col gap-2 items-center pb-1 z-10 text-white ">
        <h1 className="text-9 md:text-16 font-bold text-center tracking-px">{title}</h1>
        {showIntroductionSubtitle && (
          <h2 className="w-3/4 text-4 md:text-8 font-extrabold text-center tracking-px">
            {t('onboarding.chooseTopic')}
          </h2>
        )}
      </div>
    </>
  )
}
